import React, { createContext, useState, useMemo } from 'react';

export const ContextMenuContext = createContext();

export const ContextMenuProvider = ({ children }) => {
  const [contextMenu, setContextMenu] = useState({
    show: false,
    x: 0,
    y: 0,
    options: undefined,
  });

  const value = useMemo(() => ({ contextMenu, setContextMenu }), [contextMenu, setContextMenu]);

  return <ContextMenuContext.Provider value={value}>{children}</ContextMenuContext.Provider>;
};
